module.exports = __webpack_public_path__ + "img/c1.75c7072f.png";